export default __webpack_public_path__ + "static/media/ensaladapapa.a39cd14b.jpg";